module.exports = new __parcel__URL__("scratch01.4c8f0ff4.png").toString();